import React from 'react';
import { Link } from 'react-router-dom';

function OurCoffee() {
  return (
    <div className="w-full">
      <section id="coffee" className="w-full bg-orange-50 py-16">
        <div className="max-w-6xl mx-auto px-6 pd-1">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-6 mb-8">
            <div className="flex flex-col gap-2">
              <h2 className="font-serif text-4xl text-coffee-dark">OUR COFFEE</h2>
            </div>
            <Link to="/our-coffee" className="inline-flex items-center gap-2 text-coffee-secondary hover:text-green-700 focus:outline-none focus:ring-2 focus:ring-coffee-secondary">
              <img src="https://api.iconify.design/lucide-file-text.svg?color=%233F7C3A" alt="File icon" className="w-5 h-5"/>
              <span>Discover Our Coffee →</span>
            </Link>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/green_coffee.jpg" alt="Green coffee beans" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-bean.svg?color=%235C3A21" alt="Bean icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Green Coffee</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">Our story began with green coffee — carefully sourced from Uganda’s best-growing regions, processed with precision, and exported to international roasters and buyers who value quality and traceability.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/q.jpg" alt="Coffee roasting" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-flame.svg?color=%235C3A21" alt="Flame icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Roasted & Ground Coffee</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">Funzo Coffee does small-scale production of roasted and ground coffee, ensuring a premium local and export-ready product that captures Uganda’s authentic flavor profile.</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-sm overflow-hidden flex flex-col transition-all duration-300 hover:translate-y-[-5px] hover:shadow-md">
              <img loading="lazy" src="/images/instant.jpg?query=%22coffee%20cupping%22&w=800&h=560" alt="Coffee cupping" className="w-full h-56 object-cover"/>
              <div className="p-5 flex flex-col gap-2">
                <div className="flex items-center gap-2">
                  <img src="https://api.iconify.design/lucide-trophy.svg?color=%235C3A21" alt="Trophy icon" className="w-5 h-5"/>
                  <span className="font-semibold text-coffee-dark">Future Product: Instant Coffee</span>
                </div>
                <p className="mt-2 text-sm text-gray-600">As part of our expansion plan, we are gearing up for large-scale instant coffee production under the Uganda Coffee Value Addition Project — a major step toward industrial-scale transformation.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Value Addition Section */}
        <section id="value" className="w-full bg-gradient-to-br from-[#fefefeff] to-[#F5EFE6] py-16 pt-1 border-t border-gray-200">
        <div className="max-w-6xl mx-auto px-6 py-16 grid grid-cols-1 lg:grid-cols-2 gap-10">
          <div className="flex flex-col gap-5">
            <h2 className="font-serif text-4xl text-coffee-dark">Value Addition: Elevating Uganda’s Coffee</h2>
            <p className="mt-2 text-sm text-gray-600">
              Our approach integrates farmer training, selective processing, and market-driven roasting to create distinctive Ugandan profiles that stand out globally.
            </p>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-check-circle.svg?color=%233F7C3A" alt="Check icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Farmer Training & Mafunzo Sessions</span>
                  <span className="text-sm text-gray-600">Selective picking, fermentation control, and drying best practices.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-scale.svg?color=%233F7C3A" alt="Scale icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Quality Grading & Cupping</span>
                  <span className="text-sm text-gray-600">Defect sorting, moisture targets, and sensory evaluation.</span>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <img src="https://api.iconify.design/lucide-thermometer.svg?color=%233F7C3A" alt="Thermometer icon" className="w-5 h-5 mt-0.5"/>
                <div className="flex flex-col">
                  <span className="font-semibold text-coffee-dark">Roast Development</span>
                  <span className="text-sm text-gray-600">Profile creation tailored to origin characteristics.</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-2">
              <img src="https://api.iconify.design/lucide-info.svg?color=%235C3A21" alt="Info icon" className="w-5 h-5"/>
              <span className="text-sm text-gray-600">We publish traceability data with each lot.</span>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/B69A1426.jpg" alt="Raised bed drying" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/B69A1559.jpg" alt="Coffee cherries" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="https://app.grapesjs.com/api/assets/random-image?query=%22coffee%20drying%22&w=800&h=600" alt="Quality control lab" className="w-full h-60 object-cover"/>
            </div>
            <div className="rounded-xl overflow-hidden shadow-sm">
              <img loading="lazy" src="/images/Coffee-tours.webp" alt="Roastery equipment" className="w-full h-60 object-cover"/>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
}

export default OurCoffee;
